import { Templates, Templates_fields } from "./../models/templates_model";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";
import { module_names } from "src/app/shared/sidebar/ModuleNamesInDB";
import { ROUTES } from "src/app/shared/sidebar/menu-items";

@Injectable({
  providedIn: "root",
})
export class OpAdminTemplateService {
  constructor(private http: HttpClient) {}
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  getAllTemplate(pageId) {
    let url = environment.URL + "/template/getall?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  templateRecordById(templateId) {
    let url = environment.URL + "/template/edit/" + templateId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  templateFieldRecordById(templateId) {
    let url = environment.URL + "/template/field/edit/" + templateId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  saveTemplate(bodyParams: any) {
    let url = environment.URL + "/template/create";
    return this.http.post(url, bodyParams);
  }

  updateTemplate(bodyParams: Templates) {
    let url = environment.URL + "/template/update";
    return this.http.post(url, bodyParams);
  }
  saveOrUpdateFileFieldInTemplate(bodyParams: FormData) {
    let url = environment.URL + "/template/image/upload";
    return this.http.post(url, bodyParams);
  }

  deleteTemplate(bodyParams: Templates) {
    let url = environment.URL + "/template/delete/" + bodyParams.template_id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  deleteSubField(fieldId, subFieldId) {
    let url =
      environment.URL +
      "/template/subFieldDelete/" +
      fieldId +
      "/" +
      subFieldId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  deletePackageField(fieldId, packageFieldId) {
    let url =
      environment.URL +
      "/template/packageFieldDelete/" +
      fieldId +
      "/" +
      packageFieldId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  deleteIndividualField(fieldId, individualId) {
    let url =
      environment.URL +
      "/template/individualFieldDelete/" +
      fieldId +
      "/" +
      individualId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url =
      environment.URL + "/template/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearchForFields({
    value,
    column,
    templateId,
    pageId,
  }: {
    value;
    column;
    templateId;
    pageId;
  }) {
    let url =
      environment.URL +
      "/template/field/" +
      value +
      "/" +
      column +
      "/" +
      templateId +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  deleteTemplateField(bodyParams: Templates_fields) {
    let url = environment.URL + "/template/field/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getTemplateTypes() {
    let url = environment.URL + "/template/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  retrievePermission() {
    return JSON.parse(sessionStorage.getItem("userRolesNPermissions"));
  }

  getCodeList(codeValue) {
    let url = environment.URL + "/code/" + codeValue;
    return this.http.get(url, { headers: this.myHeaders });
  }

  templateNameUpdate(id, name){
    let url = environment.URL + "/template/name/update/" + id + "/" + name;
    return this.http.get(url, { headers: this.myHeaders });
  }
}
